import { render } from "./objective.vue?vue&type=template&id=68eb355e&ts=true"
import script from "./objective.vue?vue&type=script&lang=ts"
export * from "./objective.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__